// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"PlayIcon_playIcon__cvOZ9"};